import ApiConstant from "../../../constants/api.constants";
import Helpers from "../../../utils/helpers";
import api from "../../api";
import ConsoleType from "../../../constants/console-type.constant";
import RouteDetailsData from "./stable_data/route_details.json";
const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;
const GetRouteDetails = async (siteName: any) => {
  let apiValues = "?siteid=" + siteName;

  return await api
    .get(baseURL+ApiConstant.getRouteBySite + apiValues)
    .then(function (response: any) {
      
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });

  // return await new Promise((resolve, reject) => {
  //   // getRouteBySite

  //   resolve(RouteDetailsData.data);
  // });
};
const RouteDetails = {
  GetRouteDetails,
};
export default RouteDetails;
